/*
 * @name: 产品与服务-内容
 * @
 * @Author: 黄晓玲
 * @Date: 2022-12-01 10:13:58
 * @LastEditors: 黄晓玲
 * @LastEditTime: 2024-09-09 17:51:29
 * @Description: 描述
 */
<template>
  <div>
    <!-- <el-row :gutter="0" type="flex" justify="center">
      <div class="contentBox">
        <el-col
          :xs="22"
          :sm="20"
          :md="24"
          :lg="19"
          :xl="18"
        > -->
    <el-row :gutter="0" type="flex" justify="center">
      <el-col :xs="22" :sm="22" :md="18">
        <el-row :gutter="15">
          <el-col
            :xs="24"
            :sm="24"
            :md="12"
            v-for="(item, index) in cardData"
            :key="index"
          >
            <div class="box" @click="navgateTo(item.id)">
              <!-- :style="{ backgroundImage: 'url(' + item.url + ')' }" -->
              <img :src="item.url" class="imge-1" />
              <img :src="item.url" class="imge-2" />
              <div class="containColor">
                <div class="contain">
                  <div class="title">
                    {{ language === "zh" ? item.title : item.en_title }}
                  </div>
                  <div class="remark">{{ item.remark }}</div>
                  <div class="butt">
                    <span>{{ $t("productCenter.viewNow") }}</span>
                    <i class="el-icon-arrow-right direacion"></i>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- </el-col>
      </div>
    </el-row> -->
  </div>
</template>

<script>
import { localStorage } from "@/utils/storage.js";
import { getChildCategory } from "@/api/acticle/acticle";
import { routeName } from "@/utils/index";

export default {
  props: {
    home: Number,
  },
  data() {
    return {
      cardData: [],
    };
  },
  computed: {
    language() {
      return localStorage.get("language") || "zh";
    },
  },
  created() {
    this.load();
  },
  watch: {
    $route: "setRouteName",
  },
  methods: {
    setRouteName() {
      const pathName = routeName(this.$route.name);
      this.pathName = pathName;
      this.load();
    },
    load() {
      getChildCategory({ name: "product_show" }).then((res) => {
        if (res.code === 0) {
          if (this.home) {
            this.cardData = res.data.childrens.filter(
              (Element, index) => index < 4
            );
            return;
          }
          this.cardData = res.data.childrens;
        }
      });
    },
    navgateTo(id) {
      this.$router.push(`/productCenter/productCard/${id}`);
    },
  },
};
</script>

<style scoped>
.contentBox {
  /* margin: 0 calc((100% - 72.9vmax - 20px)/2); */
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  justify-content: stretch;
  align-items: center;
}
.box {
  margin-top: 20px;
  /* width: 36.45vmax; */
  height: 21vmax;
  /* background-image: url("../../assets/images/productCenter/1.jpg"); */
  /* background-size: 100% 100%;
  background-repeat: no-repeat; */
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.box:hover {
  /* transform: scaleX(-1); */
  /* animation-duration: 2s; */
  /* animation-name: ImgMove; */
}
@keyframes ImgMove {
  0% {
    /* transform: rotateY(0deg); */
    filter: opacity(50%);
  }
  100% {
    /* transform: rotateY(180deg); */
    filter: opacity(0);
  }
}
.contain {
  padding: 30px;
  z-index: 222;
  height: 100%;
}

.containColor {
  background-image: linear-gradient(
    to bottom right,
    rgba(255, 255, 255, 255),
    rgba(255, 255, 255, 0)
  );
  opacity: 0.8;
  height: 21vmax;
}
.imge-2,
.imge-1 {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  /* z-index: -1; */
}
.imge-1 {
  opacity: 0;
}

.box:hover .containColor {
  background-image: none;
  width: 100%;
  height: 100%;
  /* background-color: rgb(1, 90, 156); */

  background: linear-gradient(to right, rgba(1, 90, 156, 0.4), #015a9c);

  /* border-radius: 10px; */
  opacity: 0.8;
  animation-duration: 0.7s;
  animation-name: mymove;
  animation-iteration-count: 1;
  position: relative;
  overflow: hidden;
}

.box:hover .imge-1 {
  animation-duration: 0.7s;
  animation-name: mymove;
  animation-iteration-count: 1;
  opacity: 0.7;
}
@keyframes mymove {
  0% {
    transform: translate(100%);
    /* opacity: 0; */
  }
  100% {
    transform: translate(0);
    /* opacity: 0.7; */
  }
}
.box:hover .imge-2 {
  animation-duration: 0.7s;
  animation-name: mymove2;
  animation-iteration-count: 1;
  opacity: 0.7;
}
@keyframes mymove2 {
  0% {
    transform: translate(0);
  }
  100% {
    transform: translate(-100%);
  }
}
.title {
  margin-top: 2vmax;
  font-size: 28px;
  font-weight: 800;
  color: #015a9c;
}
.box:hover .title {
  color: #fff;
}
.remark {
  margin-top: 20px;
  /* height: 6vmax; */
  color: #fff;
  text-align: justify;
  font-size: 13px;
  opacity: 0;
}
.box:hover .remark {
  opacity: 1;
}
.butt {
  position: absolute;
  bottom: 40px;
  font-size: 13px;
  width: 110px;
  padding: 5px;
  border: 1px solid #fff;
  text-align: center;
  border-radius: 20px;
  opacity: 0;
}
.box:hover .butt {
  opacity: 1;
}
.direacion,
.butt > span {
  color: #fff;
}
.direacion {
  padding: 1px;
  margin-left: 20px;
  border: 1px solid #fff;
  border-radius: 50%;
  font-size: 12px;
}

@media screen and (min-width: 992px) and (max-width: 1440px) {
}
@media only screen and (max-width: 992px) {
  .contentBox {
    display: block;
    margin: 0;
  }
  .box {
    width: 100%;
    height: 45vw;
  }
  .contain {
    padding: 20px;
  }
  .containColor {
    height: 45vw;
    /* background-image: none; */
    /* opacity: 1; */
  }
  .title {
    font-size: 17px;
  }
  .remark {
    opacity: 1;
  }
  .butt {
    opacity: 1;
    position: absolute;
    bottom: 20px;
  }
}
</style>